'use client'

import { IconPigMoney } from '@tabler/icons-react'

import { safeHtml } from 'shared/utils/sanitize'
import { addTestId } from 'shared/utils/tests'

import styles from './CartSummaryDiscountSection.module.scss'

const CartSummaryDiscountSection = ({
  savings,
  tag
}: {
  savings: string | null
  tag?: string
}) => (
  <div className={styles.discountBox} {...(tag && addTestId(tag))}>
    <div className={styles.row}>
      <div className={styles.discountLabel}>
        <IconPigMoney className={styles.icon} />
        <div className={styles.discountLabelText}>
          Dzięki <b>Lokalnemu Rolnikowi</b> oszczędzasz
        </div>
      </div>
      <div
        className={styles.discountValue}
        id='cart_total_savings'
        dangerouslySetInnerHTML={{ __html: `-${safeHtml(savings)}` }}
      />
    </div>
  </div>
)

export default CartSummaryDiscountSection
